import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { cn } from '@utils/cn';
import { XMarkIcon } from './Icon';
const typeStyles = {
    success: {
        bg: 'bg-success text-white',
        icon: '✓',
    },
    error: {
        bg: 'bg-error text-white',
        icon: '✕',
    },
    info: {
        bg: 'bg-info text-white',
        icon: 'ℹ',
    },
    warning: {
        bg: 'bg-warning text-white',
        icon: '⚠',
    },
};
export function Toast({ type, message, onClose }) {
    const [isVisible, setIsVisible] = useState(true);
    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => onClose(), 300);
    };
    return (_jsxs("div", { className: cn('pointer-events-auto flex items-center gap-3 rounded-lg px-4 py-3 shadow-lg transition-all duration-300', typeStyles[type].bg, isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'), children: [_jsx("span", { className: "text-xl", children: typeStyles[type].icon }), _jsx("p", { className: "flex-1 text-sm font-medium", children: message }), _jsx("button", { onClick: handleClose, className: "rounded-full p-1 transition-colors hover:bg-white/20", "aria-label": "\u5173\u95ED", children: _jsx(XMarkIcon, { size: "sm" }) })] }));
}
